import { render, staticRenderFns } from "./SortimentCards.vue?vue&type=template&id=2cd4bbaa&scoped=true"
import script from "./SortimentCards.vue?vue&type=script&lang=js"
export * from "./SortimentCards.vue?vue&type=script&lang=js"
import style0 from "./SortimentCards.vue?vue&type=style&index=0&id=2cd4bbaa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd4bbaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd4bbaa')) {
      api.createRecord('2cd4bbaa', component.options)
    } else {
      api.reload('2cd4bbaa', component.options)
    }
    module.hot.accept("./SortimentCards.vue?vue&type=template&id=2cd4bbaa&scoped=true", function () {
      api.rerender('2cd4bbaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SortimentCards.vue"
export default component.exports